import { useMutation } from '@tanstack/react-query';
import api from '../../services/api';
import queryClient from '../queryClient';
import { QUERY_STORE_MANAGEMENT } from './useStoreManagement';

interface StoreManagementEdit {
    id: number;
    storeIds: Array<string>;
    open: boolean | null;
    active: boolean | null;
    isBlocked: boolean | null;
}

export const useStoreEdit = () => {
    const updateStoreFetch = async (data: StoreManagementEdit) => {
        const response = await api.put(
            `/app/v2/stores/edit/`,
            {},
            {
                params: {
                    open: data.open,
                    storeIds: data.storeIds,
                    active: data.active,
                    isBlocked: data.isBlocked,
                },
            },
        );
        return response.data;
    };

    return useMutation({
        mutationFn: (data: StoreManagementEdit) => updateStoreFetch(data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_STORE_MANAGEMENT],
            });
        },
    });
};
